//  Auth - Login
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

//  Auth - Logout
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// Create User
export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "CREATE_USER_FAILURE";

//  Complete KYC
export const COMPLETE_KYC = "COMPLETE_KYC";
export const COMPLETE_KYC_SUCCESS = "COMPLETE_KYC_SUCCESS";
export const COMPLETE_KYC_FAILURE = "COMPLETE_KYC_FAILURE";

//  Complete KYC
export const ACCEPT_REJECT = "ACCEPT_REJECT";
export const ACCEPT_REJECT_SUCCESS = "ACCEPT_REJECT_SUCCESS";
export const ACCEPT_REJECT_FAILURE = "ACCEPT_REJECT_FAILURE";

//  Dashboard get balance
export const GET_BALANCE = "GET_BALANCE";
export const GET_BALANCE_SUCCESS = "GET_BALANCE_SUCCESS";
export const GET_BALANCE_FAILURE = "GET_BALANCE_FAILURE";

//  Dashboard get userdata
export const GET_USERDATA = "GET_USERDATA";
export const GET_USERDATA_SUCCESS = "GET_USERDATA_SUCCESS";
export const GET_USERDATA_FAILURE = "GET_USERDATA_FAILURE";

// Dashboard deposit to moneyplant
export const DEPOSIT_MONEYPLANT = "DEPOSIT_MONEYPLANT";
export const DEPOSIT_MONEYPLANT_SUCCESS = "DEPOSIT_MONEYPLANT_SUCCESS";
export const DEPOSIT_MONEYPLANT_FAILURE = "DEPOSIT_MONEYPLANT_FAILURE";

// Dashboard add user balance
export const ADD_USER_BALANCE = "ADD_USER_BALANCE";
export const ADD_USER_BALANCE_SUCCESS = "ADD_USER_BALANCE_SUCCESS";
export const ADD_USER_BALANCE_FAILURE = "ADD_USER_BALANCE_FAILURE";

export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";

export const ADD_NEW_ADDRESS = "ADD_NEW_ADDRESS";
export const ADD_NEW_ADDRESS_SUCCESS = "ADD_NEW_ADDRESS_SUCCESS";
export const ADD_NEW_ADDRESS_FAILURE = "ADD_NEW_ADDRESS_SUCCESS";

export const GET_USERS_LIST = "GET_USERS_LIST";
export const GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS";
export const GET_USERS_LIST_FAILURE = "GET_USERS_LIST_FAILURE";

// Current ScreenWidth
export const SET_SCREEN_WIDTH = "SET_SCREEN_WIDTH";
export const SET_SCREEN_WIDTH_SUCCESS = "SET_SCREEN_WIDTH_SUCCESS";
export const SET_SCREEN_WIDTH_FAILURE = "SET_SCREEN_WIDTH_FAILURE";

// monumpay
export const REPORTS = "REPORTS";
export const REPORTS_SUCCESS = "REPORTS_SUCCESS";
export const REPORTS_FAILURE = "REPORTS_FAILURE";

export const REPORT_INFO = "REPORT_INFO";
export const REPORT_INFO_SUCCESS = "REPORT_INFO_SUCCESS";
export const REPORT_INFO_FAILURE = "REPORT_INFO_FAILURE";

export const REFUND = "REFUND";
export const REFUND_SUCCESS = "REFUND_SUCCESS";
export const REFUND_FAILURE = "REFUND_FAILURE";

// transation
export const WITHDRAWAL_LIST = "WITHDRAWAL_LIST";
export const WITHDRAWAL_LIST_SUCCESS = "WITHDRAWAL_LIST_SUCCESS";
export const WITHDRAWAL_LIST_FAILURE = "WITHDRAWAL_LIST_FAILURE";

export const DEPOSIT_LIST = "DEPOSIT_LIST";
export const DEPOSIT_LIST_SUCCESS = "DEPOSIT_LIST_SUCCESS";
export const DEPOSIT_LIST_FAILURE = "DEPOSIT_LIST_FAILURE";

export const TRANSACTION_LIST = "TRANSACTION_LIST";
export const TRANSACTION_LIST_SUCCESS = "TRANSACTION_LIST_SUCCESS";
export const TRANSACTION_LIST_FAILURE = "TRANSACTION_LIST_FAILURE";

export const ALL_TRADES_LIST = "ALL_TRADES_LIST";
export const ALL_TRADES_LIST_SUCCESS = "ALL_TRADES_LIST_SUCCESS";
export const ALL_TRADES_LIST_FAILURE = "ALL_TRADES_LIST_FAILURE";

export const WITHDRAW_ACTION = "WITHDRAW_ACTION";
export const WITHDRAW_ACTION_SUCCESS = "WITHDRAW_ACTION_SUCCESS";
export const WITHDRAW_ACTION_FAILURE = "WITHDRAW_ACTION_FAILURE";

export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_FAILURE = "UPDATE_USER_STATUS_FAILURE";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";
export const CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS";
export const CHANGE_USER_PASSWORD_FAILURE = "CHANGE_USER_PASSWORD_FAILURE";

export const GET_KYC_DETAILS = "GET_KYC_DETAILS";
export const GET_KYC_DETAILS_SUCCESS = "GET_KYC_DETAILS_SUCCESS";
export const GET_KYC_DETAILS_FAILURE = "GET_KYC_DETAILS_FAILURE";


//create whitelabels

export const ADD_WHITELABELS = "ADD_WHITELABELS";
export const ADD_WHITELABELS_SUCCESS = "ADD_WHITELABELS_SUCCESS";
export const ADD_WHITELABELS_FAILURE = "ADD_WHITELABELS_FAILURE";


//get whitelabel
export const GET_WHITELABELS = "GET_WHITELABELS";
export const GET_WHITELABELS_SUCCESS = "GET_WHITELABELS_SUCCESS";
export const GET_WHITELABELS_FAILURE = "GET_WHITELABELS_FAILURE";

//deleted users
export const DELETED_USERS = "DELETED_USERS";
export const DELETED_USERS_SUCCESS = "DELETED_USERS_SUCCESS";
export const DELETED_USERS_FAILURE = "DELETED_USERS_FAILURE";

//add crypto and bank details of whitelabel
export const ADD_BANKING = "ADD_BANKING";
export const ADD_BANKING_SUCCESS = "ADD_BANKING_SUCCESS";
export const ADD_BANKING_FAILURE = "ADD_BANKING_FAILURE";

//get partner account details of IB

export const GET_PARTNER_ACCOUNT = "GET_PARTNER_ACCOUNT";
export const GET_PARTNER_ACCOUNT_SUCCESS = "GET_PARTNER_ACCOUNT_SUCCESS";
export const GET_PARTNER_ACCOUNT_FAILURE = "GET_PARTNER_ACCOUNT_FAILURE";

// Currency Pairs
export const ADD_CURRENCY_PAIR = "ADD_CURRENCY_PAIR";
export const ADD_CURRENCY_PAIR_SUCCESS = "ADD_CURRENCY_PAIR_SUCCESS";
export const ADD_CURRENCY_PAIR_FAILURE = "ADD_CURRENCY_PAIR_FAILURE";

export const UPDATE_CURRENCY_PAIR = "UPDATE_CURRENCY_PAIR";
export const UPDATE_CURRENCY_PAIR_SUCCESS = "UPDATE_CURRENCY_PAIR_SUCCESS";
export const UPDATE_CURRENCY_PAIR_FAILURE = "UPDATE_CURRENCY_PAIR_FAILURE";

// Corporate KYC
export const GET_CORPORATE_DATA = "GET_CORPORATE_DATA";
export const GET_CORPORATE_DATA_SUCCESS = "GET_CORPORATE_DATA_SUCCESS";
export const GET_CORPORATE_DATA_FAILURE = "GET_CORPORATE_DATA_FAILURE";

export const UPDATE_CORPORATE_STATUS = "UPDATE_CORPORATE_STATUS";
export const UPDATE_CORPORATE_STATUS_SUCCESS = "UPDATE_CORPORATE_STATUS_SUCCESS";
export const UPDATE_CORPORATE_STATUS_FAILURE = "UPDATE_CORPORATE_STATUS_FAILURE";

export const FETCH_CURRENCY_PAIRS = "FETCH_CURRENCY_PAIRS";
export const FETCH_CURRENCY_PAIRS_SUCCESS = "FETCH_CURRENCY_PAIRS_SUCCESS";
export const FETCH_CURRENCY_PAIRS_FAILURE = "FETCH_CURRENCY_PAIRS_FAILURE";

export const DELETE_CURRENCY_PAIR = "DELETE_CURRENCY_PAIR";
export const DELETE_CURRENCY_PAIR_SUCCESS = "DELETE_CURRENCY_PAIR_SUCCESS";
export const DELETE_CURRENCY_PAIR_FAILURE = "DELETE_CURRENCY_PAIR_FAILURE";

// Admin Submit KYC
export const ADMIN_SUBMIT_USER_KYC = "ADMIN_SUBMIT_USER_KYC";
export const ADMIN_SUBMIT_USER_KYC_SUCCESS = "ADMIN_SUBMIT_USER_KYC_SUCCESS";
export const ADMIN_SUBMIT_USER_KYC_FAILURE = "ADMIN_SUBMIT_USER_KYC_FAILURE";

// Update Promo Code
export const UPDATE_PROMO_CODE = "UPDATE_PROMO_CODE";
export const UPDATE_PROMO_CODE_SUCCESS = "UPDATE_PROMO_CODE_SUCCESS";
export const UPDATE_PROMO_CODE_FAILURE = "UPDATE_PROMO_CODE_FAILURE";

// Update User Ref (Assign user under IB)
export const UPDATE_USER_REF = "UPDATE_USER_REF";
export const UPDATE_USER_REF_SUCCESS = "UPDATE_USER_REF_SUCCESS";
export const UPDATE_USER_REF_FAILURE = "UPDATE_USER_REF_FAILURE";

// Search Users for IB Assignment
export const SEARCH_USERS = "SEARCH_USERS";
export const SEARCH_USERS_SUCCESS = "SEARCH_USERS_SUCCESS";
export const SEARCH_USERS_FAILURE = "SEARCH_USERS_FAILURE";